import Cookies from 'js-cookie';
import { useEffect } from 'react';
export const useExitIntent = ({
  onExitIntent,
  delay = 0,
  enabled,
  optOutCookieName,
  optOutCookieExpiryDays
}) => {
  const timerStart = Date.now();
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const handleMouseLeave = event => {
      if (Date.now() - timerStart < delay) {
        return;
      }
      if (event.clientY < 0) {
        Cookies.set(optOutCookieName, 'true', {
          expires: optOutCookieExpiryDays
        });
        onExitIntent();
        document.documentElement.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
    const optOut = Cookies.get(optOutCookieName);
    if (!optOut) {
      document.documentElement?.addEventListener('mouseleave', handleMouseLeave);
      return () => {
        document.documentElement?.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [delay, enabled, onExitIntent, optOutCookieExpiryDays, optOutCookieName, timerStart]);
};